import { render, staticRenderFns } from "./KYCUpload.vue?vue&type=template&id=187db12a&scoped=true"
import script from "./KYCUpload.vue?vue&type=script&lang=js"
export * from "./KYCUpload.vue?vue&type=script&lang=js"
import style0 from "./KYCUpload.vue?vue&type=style&index=0&id=187db12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187db12a",
  null
  
)

export default component.exports